import React from 'react'
import Hero from './hero'

export default function HeroFeature(props) {
  return <Hero design={{ theme: 'light' }} {...props} />
}
